import makeStyles from '@mui/styles/makeStyles';

export const useStyle = makeStyles((theme) => ({
  richTextContainer: {
    '&.MuiTypography-root': {
      margin: '0rem 0rem 1.5rem 0rem',
      padding: 0,
      width: '100%',
      '&.no-mb': {
        marginBottom: 0
      },
      '&.xs-mb': {
        marginBottom: '0.5rem'
      },
      '&.sm-mb': {
        marginBottom: '1rem'
      },
      '&.md-mb': {
        marginBottom: '1.5rem'
      },
      '&.lg-mb': {
        marginBottom: '2rem'
      },
      '&.xl-mb': {
        marginBottom: '4rem'
      }
    }
  },
  richListContainer: {
    margin: '0rem 0rem 1.5rem 0rem',
    paddingLeft: '2rem',
    '&.lg-2col': {
      [theme.breakpoints.up('md')]: {
        columns: 2
      }
    }
  },
  richText: {
    '&.italic': {
      fontStyle: 'italic'
    },
    '&.bold': {
      fontWeight: 'bold'
    },
    '&.focus00': {
      color: theme.palette.focus00.main
    },
    '&.focus10': {
      color: theme.palette.focus10.main
    },
    '&.focus40': {
      color: theme.palette.focus40.main
    },
    '&.superscript': {
      lineHeight: '0.7em',
      fontSize: '0.7em',
      verticalAlign: 'super',
      '&.caption': {
        ...theme.typography.caption_smallRegular
      }
    },
    '&.subscript': {
      lineHeight: '0.7em',
      fontSize: '0.7em',
      verticalAlign: 'sub',
      '&.caption': {
        ...theme.typography.caption_smallRegular
      }
    },
    '&.caption': {
      ...theme.typography.caption_mediumRegular
    },
    '&.gauge': {
      ...theme.typography.title_extraLarge,
      fontWeight: '900',
      color: (props) => (props.mainColor)
    },
    '&.light': {
      fontWeight: '500'
    },
    '&.no-tcc': {
      // no text color contrast
      color: 'inherit',
      filter: 'none',
      WebkitFilter: 'none'
    },
    '&.preformatted': {
      whiteSpace: 'pre-wrap'
    }
  }
}));
